import type { AppDispatch } from '@/app/store';
import { fetchPublicWebinarSession } from '@/features/webinar/webinarThunks';
import {
  createSessionRefetchScheduler,
  type SessionRefetchScheduler,
} from '@/lib/liveOpeningJitter';

/** Relecture de la session par la salle d'attente sur signal de mise à jour, étalée par spectateur. */
export function createWaitingRoomSessionRefetch(
  dispatch: AppDispatch,
  webinarId: number,
  sessionIdentifier: string,
  delayMs: number,
): SessionRefetchScheduler {
  return createSessionRefetchScheduler(delayMs, async () => {
    const action = await dispatch(fetchPublicWebinarSession({ webinarId, sessionIdentifier }));
    if (!fetchPublicWebinarSession.fulfilled.match(action)) return 'failed';
    return action.payload.session?.status === 'IN_PROGRESS' ? 'live' : 'waiting';
  });
}
